<template>
  <div class="row">
    <div class="col-lg-8 inline">
      <h2>Asset Graph</h2>
    </div>
    <div class="col-lg-4">
      <span class="demonstration">Select Date Range :</span>
      <el-date-picker
        v-model="value2"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="To"
        start-placeholder="Start date"
        end-placeholder="End date"
        :picker-options="pickerOptions"
        @change="getDate()"
      ></el-date-picker>
    </div>
    <div class="col-lg">
      <h4>
        Select Interval :
        <el-select
          class="select-primary tab"
          placeholder="Single Select"
          v-model="selects.simple_interval"
          @change="getData()"
        >
          <el-option
            v-for="option in selects.interval"
            class="select-primary"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          ></el-option>
        </el-select>
      </h4>
    </div>
    <div class="col-lg">
      <h4>
        Select Site :
        <el-select
          class="select-primary tab"
          placeholder="Single Select"
          v-model="selects.simple_site"
          @change="getSiteData()"
        >
          <el-option
            v-for="option in selects.site"
            class="select-primary"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          ></el-option>
        </el-select>
      </h4>
    </div>
    <div class="col-lg-12">
      <hr />
    </div>
    <div class="col-lg-6 col-md-12">
      <card class="card-chart" no-footer-line>
        <template slot="header">
          <h5 class="card-category">Weekly</h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>Number of Assets</b>
          </h3>
        </template>
        <div class="chart-area">
          <line-chart
            v-if="totalassetChart.loaded"
            :chart-data="totalassetChart.chartData"
            :gradient-colors="totalassetChart.gradientColors"
            :gradient-stops="totalassetChart.gradientStops"
            :extra-options="totalassetChart.extraOptions"
            :height="200"
          ></line-chart>
          <div class="d-flex justify-content-center spinner" v-if="!totalassetChart.loaded">
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
    <div class="col-lg-6 col-md-12">
      <card class="card-chart" no-footer-line>
        <template slot="header">
          <h5 class="card-category">Weekly</h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>Asset owned by AFES</b>
          </h3>
        </template>
        <div class="chart-area">
          <line-chart
            v-if="propertyDhesChart.loaded"
            :chart-data="propertyDhesChart.chartData"
            :gradient-colors="propertyDhesChart.gradientColors"
            :gradient-stops="propertyDhesChart.gradientStops"
            :extra-options="propertyDhesChart.extraOptions"
            :height="200"
          ></line-chart>
          <div class="d-flex justify-content-center spinner" v-if="!propertyDhesChart.loaded">
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
    <div class="col-lg-6 col-md-12">
      <card class="card-chart" no-footer-line>
        <template slot="header">
          <h5 class="card-category">Weekly</h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>Asset owned by Contractor</b>
          </h3>
        </template>
        <div class="chart-area">
          <line-chart
            v-if="propertyContractorChart.loaded"
            :chart-data="propertyContractorChart.chartData"
            :gradient-colors="propertyContractorChart.gradientColors"
            :gradient-stops="propertyContractorChart.gradientStops"
            :extra-options="propertyContractorChart.extraOptions"
            :height="200"
          ></line-chart>
          <div class="d-flex justify-content-center spinner" v-if="!propertyContractorChart.loaded">
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
    <div class="col-lg-6 col-md-12">
      <card class="card-chart" no-footer-line>
        <template slot="header">
          <h5 class="card-category">Weekly</h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>Number of Operational Assets</b>
          </h3>
        </template>
        <div class="chart-area">
          <line-chart
            v-if="operationalChart.loaded"
            :chart-data="operationalChart.chartData"
            :gradient-colors="operationalChart.gradientColors"
            :gradient-stops="operationalChart.gradientStops"
            :extra-options="operationalChart.extraOptions"
            :height="200"
          ></line-chart>
          <div class="d-flex justify-content-center spinner" v-if="!operationalChart.loaded">
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
    <div class="col-lg-6 col-md-12">
      <card class="card-chart" no-footer-line>
        <template slot="header">
          <h5 class="card-category">Weekly</h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>Number of Available Assets</b>
          </h3>
        </template>
        <div class="chart-area">
          <line-chart
            v-if="nonOperationalChart.loaded"
            :chart-data="nonOperationalChart.chartData"
            :gradient-colors="nonOperationalChart.gradientColors"
            :gradient-stops="nonOperationalChart.gradientStops"
            :extra-options="nonOperationalChart.extraOptions"
            :height="200"
          ></line-chart>
          <div class="d-flex justify-content-center spinner" v-if="!nonOperationalChart.loaded">
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
    <div class="col-lg-6 col-md-12">
      <card class="card-chart" no-footer-line>
        <template slot="header">
          <h5 class="card-category">Weekly</h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>Number of Breakdown Assets</b>
          </h3>
        </template>
        <div class="chart-area">
          <line-chart
            v-if="breakdownChart.loaded"
            :chart-data="breakdownChart.chartData"
            :gradient-colors="breakdownChart.gradientColors"
            :gradient-stops="breakdownChart.gradientStops"
            :extra-options="breakdownChart.extraOptions"
            :height="200"
          ></line-chart>
          <div class="d-flex justify-content-center spinner" v-if="!breakdownChart.loaded">
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
    <div class="col-lg-6 col-md-12">
      <card class="card-chart" no-footer-line>
        <template slot="header">
          <h5 class="card-category">Weekly</h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>Number of Under-Repair Assets</b>
          </h3>
        </template>
        <div class="chart-area">
          <line-chart
            v-if="underRepairChart.loaded"
            :chart-data="underRepairChart.chartData"
            :gradient-colors="underRepairChart.gradientColors"
            :gradient-stops="underRepairChart.gradientStops"
            :extra-options="underRepairChart.extraOptions"
            :height="200"
          ></line-chart>
          <div class="d-flex justify-content-center spinner" v-if="!underRepairChart.loaded">
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
    <!-- <div class="col-lg-6 col-md-12">
      <card type="chart">
        <template slot="header">
          <h5 class="card-category">
            <b>Weekly</b>
          </h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>Number of Proposed BER Assets</b>
          </h3>
        </template>
        <div class="chart-area">
          <line-chart
            v-if="proposedBERChart.loaded"
            :chart-data="proposedBERChart.chartData"
            :gradient-colors="proposedBERChart.gradientColors"
            :gradient-stops="proposedBERChart.gradientStops"
            :extra-options="proposedBERChart.extraOptions"
            :height="200"
          ></line-chart>
          <div class="d-flex justify-content-center spinner" v-if="!proposedBERChart.loaded">
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div> -->
    <div class="col-lg-6 col-md-12">
      <card type="chart">
        <template slot="header">
          <h5 class="card-category">
            <b>Weekly</b>
          </h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>Number of PPM done</b>
          </h3>
        </template>
        <div class="chart-area">
          <line-chart
            v-if="ppmDoneChart.loaded"
            :chart-data="ppmDoneChart.chartData"
            :gradient-colors="ppmDoneChart.gradientColors"
            :gradient-stops="ppmDoneChart.gradientStops"
            :extra-options="ppmDoneChart.extraOptions"
            :height="200"
          ></line-chart>
          <div class="d-flex justify-content-center spinner" v-if="!ppmDoneChart.loaded">
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
    <div class="col-lg-6 col-md-12">
      <card type="chart">
        <template slot="header">
          <h5 class="card-category">
            <b>Weekly</b>
          </h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>Number of PPM under maintenance</b>
          </h3>
        </template>
        <div class="chart-area">
          <line-chart
            v-if="ppmUnderMaintenanceChart.loaded"
            :chart-data="ppmUnderMaintenanceChart.chartData"
            :gradient-colors="ppmUnderMaintenanceChart.gradientColors"
            :gradient-stops="ppmUnderMaintenanceChart.gradientStops"
            :extra-options="ppmUnderMaintenanceChart.extraOptions"
            :height="200"
          ></line-chart>
          <div class="d-flex justify-content-center spinner" v-if="!ppmUnderMaintenanceChart.loaded">
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
    <div class="col-lg-6 col-md-12">
      <card type="chart">
        <template slot="header">
          <h5 class="card-category">
            <b>Weekly</b>
          </h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>Number of overdue PPM</b>
          </h3>
        </template>
        <div class="chart-area">
          <line-chart
            v-if="overduePPMChart.loaded"
            :chart-data="overduePPMChart.chartData"
            :gradient-colors="overduePPMChart.gradientColors"
            :gradient-stops="overduePPMChart.gradientStops"
            :extra-options="overduePPMChart.extraOptions"
            :height="200"
          ></line-chart>
          <div class="d-flex justify-content-center spinner" v-if="!overduePPMChart.loaded">
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
    <div class="col-lg col-md-12">
      <card type="chart">
        <template slot="header">
          <h5 class="card-category">
            <b>Weekly</b>
          </h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b class>Percentage of Asset Utilization</b>
          </h3>
        </template>
        <div class="chart-area">
          <line-chart
            v-if="assetUtilizationChart.loaded"
            :chart-data="assetUtilizationChart.chartData"
            :gradient-colors="assetUtilizationChart.gradientColors"
            :gradient-stops="assetUtilizationChart.gradientStops"
            :extra-options="assetUtilizationChart.extraOptions"
            :height="200"
          ></line-chart>
          <div class="d-flex justify-content-center spinner" v-if="!assetUtilizationChart.loaded">
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";
import * as chartConfigs from "@/components/Charts/config";
import config from "@/config";
import { Select, Option, DatePicker } from "element-ui";
import moment from "moment";
import { Circle8 } from "vue-loading-spinner";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    LineChart,
    BarChart,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    Loading,
    Circle8
  },
  data() {
    return {
      isLoading: true,
      // Selecting interval data
      selects: {
        site: [],
        simple_site: "",
        simple_interval: "",
        interval: [
          {
            label: "Monthly",
            value: "month"
          },
          {
            label: "Daily",
            value: "day"
          }
        ]
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "Last week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          // {
          //   text: "Last 3 months",
          //   onClick(picker) {
          //     const end = new Date();
          //     const start = new Date();
          //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          //     picker.$emit("pick", [start, end]);
          //   }
          // },
          {
            text: "Last year",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      value1: "",
      value2: "",
      enddate: "",
      startdate: "",
      ppmDoneChart: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "PPM Done",
              fill: true,
              borderColor: "rgba(52, 128, 252, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(52, 128, 252, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80]
            }
          ]
        },
        loaded: false,
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(52, 128, 252, 0.7)",
          "rgba(52, 128, 252, 0.0)",
          "rgba(52, 128, 252, 0.0)"
        ],
        gradientStops: [1, 0.4, 0]
      },
      propertyDhesChart: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Property of AFES",
              fill: true,
              borderColor: "rgba(255, 140, 0, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(255, 140, 0, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80]
            }
          ]
        },
        loaded: false,
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(255, 140, 0, 0.7)",
          "rgba(255, 140, 0, 0.0)",
          "rgba(255, 140, 0, 0.0)"
        ],
        gradientStops: [1, 0.4, 0]
      },
      // orangeLineChart: {
      //   chartData: {
      //     labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
      //     datasets: [
      //       {
      //         label: "Replacement",
      //         fill: true,
      //         borderColor: "rgba(255, 140, 0, 1)",
      //         borderWidth: 2,
      //         borderDash: [],
      //         borderDashOffset: 0.0,
      //         pointBackgroundColor: "rgba(255, 140, 0, 1)",
      //         pointBorderColor: "rgba(255,255,255,0)",
      //         pointHoverBackgroundColor: "#be55ed",
      //         pointBorderWidth: 20,
      //         pointHoverRadius: 4,
      //         pointHoverBorderWidth: 15,
      //         pointRadius: 4,
      //         data: [80, 130, 70, 100, 120, 80]
      //       }
      //     ]
      //   },
      //   loaded: false,
      //   extraOptions: chartConfigs.purpleChartOptions,
      //   gradientColors: [
      //     "rgba(255, 140, 0, 0.7)",
      //     "rgba(255, 140, 0, 0.0)",
      //     "rgba(255, 140, 0, 0.0)"
      //   ],
      //   gradientStops: [1, 0.4, 0]
      // },
      propertyContractorChart: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Property of Contractor",
              fill: true,
              borderColor: "rgba(128, 0, 0, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(128, 0, 0, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80]
            }
          ]
        },
        loaded: false,
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(128, 0, 0, 0.7)",
          "rgba(128, 0, 0, 0.0)",
          "rgba(128, 0, 0, 0.0)"
        ],
        gradientStops: [1, 0.4, 0]
      },
      // maroonLineChart: {
      //   chartData: {
      //     labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
      //     datasets: [
      //       {
      //         label: "Replacement",
      //         fill: true,
      //         borderColor: "rgba(128, 0, 0, 1)",
      //         borderWidth: 2,
      //         borderDash: [],
      //         borderDashOffset: 0.0,
      //         pointBackgroundColor: "rgba(128, 0, 0, 1)",
      //         pointBorderColor: "rgba(255,255,255,0)",
      //         pointHoverBackgroundColor: "#be55ed",
      //         pointBorderWidth: 20,
      //         pointHoverRadius: 4,
      //         pointHoverBorderWidth: 15,
      //         pointRadius: 4,
      //         data: [80, 130, 70, 100, 120, 80]
      //       }
      //     ]
      //   },
      //   loaded: false,
      //   extraOptions: chartConfigs.purpleChartOptions,
      //   gradientColors: [
      //     "rgba(128, 0, 0, 0.7)",
      //     "rgba(128, 0, 0, 0.0)",
      //     "rgba(128, 0, 0, 0.0)"
      //   ],
      //   gradientStops: [1, 0.4, 0]
      // },
      // bananaLineChart: {
      //   chartData: {
      //     labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
      //     datasets: [
      //       {
      //         label: "Replacement",
      //         fill: true,
      //         borderColor: "rgba(255, 252, 121, 1)",
      //         borderWidth: 2,
      //         borderDash: [],
      //         borderDashOffset: 0.0,
      //         pointBackgroundColor: "rgba(255, 252, 121, 1)",
      //         pointBorderColor: "rgba(255,255,255,0)",
      //         pointHoverBackgroundColor: "#be55ed",
      //         pointBorderWidth: 20,
      //         pointHoverRadius: 4,
      //         pointHoverBorderWidth: 15,
      //         pointRadius: 4,
      //         data: [80, 130, 70, 100, 120, 80]
      //       }
      //     ]
      //   },
      //   loaded: false,
      //   extraOptions: chartConfigs.purpleChartOptions,
      //   gradientColors: [
      //     "rgba(255, 252, 121, 0.7)",
      //     "rgba(255, 252, 121, 0.0)",
      //     "rgba(255, 252, 121, 0.0)"
      //   ],
      //   gradientStops: [1, 0.4, 0]
      // },
      nonOperationalChart: {
        chartData: {
          labels: [],
            datasets: [
              {
                label: "Non Operational",
                fill: true,
                borderColor: "rgba(187, 225, 250, 1)",
                borderWidth: 2,
                borderDash: [],
                borderDashOffset: 0.0,
                pointBackgroundColor: "rgba(187, 225, 250, 1)",
                pointBorderColor: "rgba(255,255,255,0)",
                pointHoverBackgroundColor: "#be55ed",
                pointBorderWidth: 20,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 15,
                pointRadius: 4,
                data: []
              }
            ]
        },
        loaded: true,
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(187, 225, 250, 0.7)",
          "rgba(187, 225, 250, 0.0)",
          "rgba(187, 225, 250, 0.0)"
        ],
        gradientStops: [1, 0.4, 0]
      },
      underRepairChart: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Under Repair",
              fill: true,
              borderColor: "rgba(210, 84, 143, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(210, 84, 143, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80]
            }
          ]
        },
        loaded: false,
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(210, 84, 143, 0.5)",
          "rgba(210, 84, 143, 0.0)",
          "rgba(210, 84, 143, 0.0)"
        ],
        gradientStops: [1, 0.4, 0]
      },
      proposedBERChart: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Proposed BER",
              fill: true,
              borderColor: "rgba(237, 28, 36, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(237, 28, 36, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80]
            }
          ]
        },
        loaded: false,
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(237, 28, 36, 0.5)",
          "rgba(237, 28, 36, 0.0)",
          "rgba(237, 28, 36, 0.0)"
        ],
        gradientStops: [1, 0.4, 0]
      },
      breakdownChart: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Breakdown",
              fill: true,
              borderColor: "rgba(94, 170, 30, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(94, 170, 30, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80]
            }
          ]
        },
        loaded: false,
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(94, 170, 30, 0.5)",
          "rgba(94, 170, 30, 0.0)",
          "rgba(94, 170, 30, 0.0)"
        ],
        gradientStops: [1, 0.4, 0]
      },
      totalassetChart: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Total Asset",
              fill: true,
              borderColor: "rgba(94, 170, 30, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(94, 170, 30, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80]
            }
          ]
        },
        loaded: false,
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(94, 170, 30, 0.5)",
          "rgba(94, 170, 30, 0.0)",
          "rgba(94, 170, 30, 0.0)"
        ],
        gradientStops: [1, 0.4, 0]
      },
      overduePPMChart: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Overdue PPM",
              fill: true,
              borderColor: "rgba(94, 170, 30, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(94, 170, 30, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80]
            }
          ]
        },
        loaded: false,
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(94, 170, 30, 0.5)",
          "rgba(94, 170, 30, 0.0)",
          "rgba(94, 170, 30, 0.0)"
        ],
        gradientStops: [1, 0.4, 0]
      },
      ppmUnderMaintenanceChart: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "PPM Undermaintenance",
              fill: true,
              borderColor: "rgb(140, 100, 203, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgb(140, 100, 203, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80]
            }
          ]
        },
        loaded: false,
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(140, 100, 203, 0.7)",
          "rgba(140, 100, 203, 0.0)",
          "rgba(140, 100, 203, 0)"
        ],
        gradientStops: [1, 0.4, 0]
      },
      operationalChart: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Operational",
              fill: true,
              borderColor: "rgb(246, 206, 71, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgb(246, 206, 71, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [0, 130, 70, 100, 120, 80]
            }
          ]
        },
        loaded: false,
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(246, 206, 71, 0.5)",
          "rgba(246, 206, 71, 0.0)",
          "rgba(246, 206, 71, 0.0)"
        ],
        gradientStops: [1, 0.4, 0]
      },
      assetUtilizationChart: {
        chartData: {
          labels: ["JUL", "AUG", "amirah", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Asset Utilization",
              fill: true,
              borderColor: "rgb(246, 206, 71, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgb(246, 206, 71, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80]
            }
          ]
        },
        loaded: false,
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(246, 206, 71, 0.5)",
          "rgba(246, 206, 71, 0.0)",
          "rgba(246, 206, 71, 0.0)"
        ],
        gradientStops: [1, 0.4, 0]
      },

      loaded: false
    };
  },
  methods: {
    getAnalytic(response){
      console.log(response)
      this.breakdownChart.loaded = false
      this.totalassetChart.loaded = false
      this.propertyDhesChart.loaded = false
      this.propertyContractorChart = false
      this.operationalChart.loaded = false
      this.nonOperationalChart.loaded = false
      this.underRepairChart.loaded = false
      this.proposedBERChart.loaded = false
      this.ppmDoneChart.loaded = false
      this.ppmUnderMaintenanceChart.loaded = false
      this.overduePPMChart.loaded = false
      this.assetUtilizationChart.loaded = false


      // let interval = this.selects.simple_interval
      // let startdate = 0
      // let enddate = 0
      // if(this.selects.simple_interval == "month"){
      //   startdate = moment(this.startdate).unix()
      //   enddate = moment(this.enddate).unix()
      // } else {
      //   startdate = moment(this.startdate).unix()
      //   enddate = moment(this.enddate).unix()
      // }
      
      // console.log(startdate, enddate)
      
      // 
      let totalasset = response.TotalAsset
      let breakdown = response.Breakdown
      let nonoperational = response.NonOperational
      let operational = response.Operational
      let ppmdone = response.PPMDone
      let ppmoverdue = response.PPMOverdue
      let propertycontractor = response.PropertyContractor
      let propertyDHES = response.PropertyDHES
      
      let undermaintenance = response.UnderMaintenance
      let underrepair = response.UnderRepair
      let utilization = response.Utilization
      let proposeBER = response.ProposedBER
            
        
            
      // daterange 
      let tadaterange = []
      let brdaterange = []
      let pDdaterange = []
      let pCdaterange = []
      let oAdaterange = []
      let noAdaterange = []
      let underrepairdaterange = []
      let proposeberdaterange = []
      let ppmdaterange = []
      let ppmundermaintenance = []
      let overdueppmdaterange = []
      let assetutilizationdaterange = []

      // total asset
      let TotalAsset = []
      let Breakdown = []
      
      let PropertybyDhes = []
      let PropertybyContractor = []
      let Operational = []
      
      let NonOperational = []
      
      let UnderRepair = []
      
      let ProposedBER = []
      
      let PPMDone = []
      
      let PPMUnderMaintenance = []
      
      let OverduePPM = []
      
      let AssetUtilization = []
      

      let month = moment.monthsShort('MMMMMM')
      
      // console.log(breakdown)
      console.log(totalasset)

      if(this.selects.simple_interval == 'month'){

        for(var i=0; i<month.length; i++){
          // console.log(month[i].toString().toUpperCase())
          let m = month[i].toString().toUpperCase()
          // console.log(JSON.stringify(month[i]).toUpperCase())
          tadaterange.push(m)
          brdaterange.push(m)
          pDdaterange.push(m)
          pCdaterange.push(m)
          oAdaterange.push(m)
          noAdaterange.push(m)
          underrepairdaterange.push(m)
          proposeberdaterange.push(m)
          ppmdaterange.push(m)
          ppmundermaintenance.push(m)
          overdueppmdaterange.push(m)
          assetutilizationdaterange.push(m)
        }
        // breakdown
        for(var j=0; j<brdaterange.length; j++){
          let ttlbreakdown = 0
          for(var i=0; i<breakdown.length; i++){
            let date = moment(breakdown[i].Date).format("MMM")
            if( date.toString().toUpperCase() == brdaterange[j]){
              ttlbreakdown += breakdown[i].Count
            } 
          }
          Breakdown[j] = ttlbreakdown
        }

        // totalasset
        for(var j=0; j<tadaterange.length; j++){
          let ttltotalasset = 0
          for(var i=0; i<totalasset.length; i++){
            let date = moment(totalasset[i].Date).format("MMM")
            if( date.toString().toUpperCase() == tadaterange[j]){
              ttltotalasset += totalasset[i].Count
            }
          }
          TotalAsset[j] = ttltotalasset
        }

        // asset owned by DHES
        for(var j=0; j<pDdaterange.length; j++){
          let ttlpropertyDhes = 0
          for(var i=0; i<propertyDHES.length; i++){
            let date = moment(propertyDHES[i].Date).format("MMM")
            if( date.toString().toUpperCase() == pDdaterange[j]){
              ttlpropertyDhes += propertyDHES[i].Count
            }
          }
          PropertybyDhes[j] = ttlpropertyDhes
        }
        
        // asset owned by Contractor
        for(var j=0; j<pCdaterange.length; j++){
          let ttlpropertyContractor = 0
          for(var i=0; i<propertycontractor.length; i++){
            let date = moment(propertycontractor[i].Date).format("MMM")
            if( date.toString().toUpperCase() == pCdaterange[j]){
              ttlpropertyContractor += propertycontractor[i].Count
            }
          }
          PropertybyContractor[j] = ttlpropertyContractor
        }

        // operational assets
        for(var j=0; j<oAdaterange.length; j++){
          let ttloperational = 0
          for(var i=0; i<operational.length; i++){
            let date = moment(operational[i].Date).format("MMM")
            if( date.toString().toUpperCase() == oAdaterange[j]){
              ttloperational += operational[i].Count
            }
          }
          Operational[j] = ttloperational
        }

        // non operational assets
        for(var j=0; j<noAdaterange.length; j++){
          let ttlnonoperational = 0
          for(var i=0; i<nonoperational.length; i++){
            let date = moment(nonoperational[i].Date).format("MMM")
            if( date.toString().toUpperCase() == noAdaterange[j]){
              ttlnonoperational += nonoperational[i].Count
            }
          }
          NonOperational[j] = ttlnonoperational
        }

        // under repair assets
        for(var j=0; j<underrepairdaterange.length; j++){
          let ttlunderrepair = 0
          for(var i=0; i<underrepair.length; i++){
            let date = moment(underrepair[i].Date).format("MMM")
            if( date.toString().toUpperCase() == underrepairdaterange[j]){
              ttlunderrepair += underrepair[i].Count
            }
          }
          UnderRepair[j] = ttlunderrepair
        }

        // proposed BER
        for(var j=0; j<proposeberdaterange.length; j++){
          let ttlproposedber = 0
          for(var i=0; i<proposeBER.length; i++){
            let date = moment(proposeBER[i].Date).format("MMM")
            if( date.toString().toUpperCase() == proposeberdaterange[j]){
              ttlproposedber += proposeBER[i].Count
            }
          }
          ProposedBER[j] = ttlproposedber
        }
              
        // PPM Done
        for(var j=0; j<ppmdaterange.length; j++){
          let ttlppmdone = 0
          for(var i=0; i<ppmdone.length; i++){
            let date = moment(ppmdone[i].Date).format("MMM")
            if( date.toString().toUpperCase() == ppmdaterange[j]){
              ttlppmdone += ppmdone[i].Count
            }
          }
          PPMDone[j] = ttlppmdone
        }      

        // PPM Under Maintenance
        for(var j=0; j<ppmundermaintenance.length; j++){
          let ttlppmundermaintenance = 0
          for(var i=0; i<undermaintenance.length; i++){
            let date = moment(undermaintenance[i].Date).format("MMM")
            if( date.toString().toUpperCase() == ppmundermaintenance[j]){
              ttlppmundermaintenance += undermaintenance[i].Count
            }
          }
          PPMUnderMaintenance[j] = ttlppmundermaintenance
        }   

        // overdue PPM
        for(var j=0; j<overdueppmdaterange.length; j++){
          let ttloverdueppm = 0
          for(var i=0; i<ppmoverdue.length; i++){
            let date = moment(ppmoverdue[i].Date).format("MMM")
            if( date.toString().toUpperCase() == overdueppmdaterange[j]){
              ttloverdueppm += ppmoverdue[i].NoOverdue
            }
          }
          OverduePPM[j] = ttloverdueppm
        }   

        // percentage asset utilization
        for(var j=0; j<assetutilizationdaterange.length; j++){
          let ttlassetutilization = 0
          for(var i=0; i<utilization.length; i++){
            let date = moment(utilization[i].Date).format("MMM")
            if( date.toString().toUpperCase() == assetutilizationdaterange[j]){
              ttlassetutilization += utilization[i].AssetUtilization
            }
          }
          AssetUtilization[j] = ttlassetutilization
        }  
      } else {
        // breakdown
        for(var i=0; i<breakdown.length; i++){
          brdaterange.push(moment(breakdown[i].Date).format("YYYY-MM-DD"))
          Breakdown.push(breakdown[i].Count)
        }

        // totalasset
        for(var i=0; i<totalasset.length; i++){
          tadaterange.push(moment(totalasset[i].Date).format("YYYY-MM-DD"))
          TotalAsset.push(totalasset[i].Count)
        }  

        // asset owned by DHES
        for(var i=0; i<propertyDHES.length; i++){
          pDdaterange.push(moment(propertyDHES[i].Date).format("YYYY-MM-DD"))
          PropertybyDhes.push(propertyDHES[i].Count)
        }

        // asset owned by Contractor
        for(var i=0; i<propertycontractor.length; i++){
          pCdaterange.push(moment(propertycontractor[i].Date).format("YYYY-MM-DD"))
          PropertybyContractor.push(propertycontractor[i].Count)
        }
              
        // operational assets
        for(var i=0; i<operational.length; i++){
          oAdaterange.push(moment(operational[i].Date).format("YYYY-MM-DD"))
          Operational.push(operational[i].Count)
        }

        // non operational assets
        for(var i=0; i<nonoperational.length; i++){
          noAdaterange.push(moment(nonoperational[i].Date).format("YYYY-MM-DD"))
          NonOperational.push(nonoperational[i].Count)
        }

        // under repair assets
        for(var i=0; i<underrepair.length; i++){
          underrepairdaterange.push(moment(underrepair[i].Date).format("YYYY-MM-DD"))
          UnderRepair.push(underrepair[i].Count)
        }

        // proposed BER
        for(var i=0; i<proposeBER.length; i++){
          proposeberdaterange.push(moment(proposeBER[i].Date).format("YYYY-MM-DD"))
          ProposedBER.push(proposeBER[i].Count)
        }
              
        // PPM Done
        for(var i=0; i<ppmdone.length; i++){
          ppmdaterange.push(moment(ppmdone[i].Date).format("YYYY-MM-DD"))
          PPMDone.push(ppmdone[i].Count)
        }

        // PPM Under Maintenance
        for(var i=0; i<undermaintenance.length; i++){
          ppmundermaintenance.push(moment(undermaintenance[i].Date).format("YYYY-MM-DD"))
          PPMUnderMaintenance.push(undermaintenance[i].Count)
        }

        // overdue PPM
        for(var i=0; i<ppmoverdue.length; i++){
          overdueppmdaterange.push(moment(ppmoverdue[i].Date).format("YYYY-MM-DD"))
          OverduePPM.push(ppmoverdue[i].NoOverdue)
        }

        // percentage asset utilization
        for(var i=0; i<utilization.length; i++){
          assetutilizationdaterange.push(moment(utilization[i].Date).format("YYYY-MM-DD"))
          AssetUtilization.push(utilization[i].AssetUtilization)
        }
      }
            
            this.totalassetChart = {
              chartData: {
                labels: tadaterange,
                datasets: [
                  {
                    label: "Total Asset",
                    fill: true,
                    borderColor: "rgba(94, 170, 30, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: "rgba(94, 170, 30, 1)",
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#be55ed",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: TotalAsset
                  }
                ]
              },
              loaded: false,
              extraOptions: chartConfigs.purpleChartOptions,
              gradientColors: [
                "rgba(94, 170, 30, 0.5)",
                "rgba(94, 170, 30, 0.0)",
                "rgba(94, 170, 30, 0.0)"
              ],
              gradientStops: [1, 0.4, 0]
            }
            this.totalassetChart.loaded = true
            
            this.breakdownChart = {
              chartData: {
                labels: brdaterange,
                datasets: [
                  {
                    label: "Breakdown",
                    fill: true,
                    borderColor: "rgba(94, 170, 30, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: "rgba(94, 170, 30, 1)",
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#be55ed",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: Breakdown
                  }
                ]
              },
              loaded: false,
              extraOptions: chartConfigs.purpleChartOptions,
              gradientColors: [
                "rgba(94, 170, 30, 0.5)",
                "rgba(94, 170, 30, 0.0)",
                "rgba(94, 170, 30, 0.0)"
              ],
              gradientStops: [1, 0.4, 0]
            }
            this.breakdownChart.loaded = true

            this.propertyDhesChart =  {
              chartData: {
                labels: pDdaterange,
                datasets: [
                  {
                    label: "Property of AFES",
                    fill: true,
                    borderColor: "rgba(255, 140, 0, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: "rgba(255, 140, 0, 1)",
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#be55ed",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: PropertybyDhes
                  }
                ]
              },
              loaded: false,
              extraOptions: chartConfigs.purpleChartOptions,
              gradientColors: [
                "rgba(255, 140, 0, 0.7)",
                "rgba(255, 140, 0, 0.0)",
                "rgba(255, 140, 0, 0.0)"
              ],
              gradientStops: [1, 0.4, 0]
            }
            this.propertyDhesChart.loaded = true
            
            this.propertyContractorChart = {
              chartData: {
                labels: pCdaterange,
                datasets: [
                  {
                    label: "Property of Contractor",
                    fill: true,
                    borderColor: "rgba(128, 0, 0, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: "rgba(128, 0, 0, 1)",
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#be55ed",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: PropertybyContractor
                  }
                ]
              },
              loaded: false,
              extraOptions: chartConfigs.purpleChartOptions,
              gradientColors: [
                "rgba(128, 0, 0, 0.7)",
                "rgba(128, 0, 0, 0.0)",
                "rgba(128, 0, 0, 0.0)"
              ],
              gradientStops: [1, 0.4, 0]
            }
            this.propertyContractorChart.loaded = true

            this.operationalChart = {
              chartData: {
                labels: oAdaterange,
                datasets: [
                  {
                    label: "Operational",
                    fill: true,
                    borderColor: "rgb(246, 206, 71, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: "rgb(246, 206, 71, 1)",
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#be55ed",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: Operational
                  }
                ]
              },
              loaded: false,
              extraOptions: chartConfigs.purpleChartOptions,
              gradientColors: [
                "rgba(246, 206, 71, 0.5)",
                "rgba(246, 206, 71, 0.0)",
                "rgba(246, 206, 71, 0.0)"
              ],
              gradientStops: [1, 0.4, 0]
            }
            this.operationalChart.loaded = true

            this.nonOperationalChart = {
              chartData: {
                labels: noAdaterange,
                datasets: [
                  {
                    label: "Non Operational",
                    fill: true,
                    borderColor: "rgba(187, 225, 250, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: "rgba(187, 225, 250, 1)",
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#be55ed",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: NonOperational
                  }
                ]
              },
              loaded: false,
              extraOptions: chartConfigs.purpleChartOptions,
              gradientColors: [
                "rgba(187, 225, 250, 0.7)",
                "rgba(187, 225, 250, 0.0)",
                "rgba(187, 225, 250, 0.0)"
              ],
              gradientStops: [1, 0.4, 0]
            }
            this.nonOperationalChart.loaded = true

            this.underRepairChart = {
              chartData: {
                labels: underrepairdaterange,
                datasets: [
                  {
                    label: "Under Repair",
                    fill: true,
                    borderColor: "rgba(210, 84, 143, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: "rgba(210, 84, 143, 1)",
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#be55ed",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: UnderRepair
                  }
                ]
              },
              loaded: false,
              extraOptions: chartConfigs.purpleChartOptions,
              gradientColors: [
                "rgba(210, 84, 143, 0.5)",
                "rgba(210, 84, 143, 0.0)",
                "rgba(210, 84, 143, 0.0)"
              ],
              gradientStops: [1, 0.4, 0]
            }
            this.underRepairChart.loaded = true

            this.proposedBERChart = {
              chartData: {
                labels: proposeberdaterange,
                datasets: [
                  {
                    label: "Proposed BER",
                    fill: true,
                    borderColor: "rgba(237, 28, 36, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: "rgba(237, 28, 36, 1)",
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#be55ed",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: ProposedBER
                  }
                ]
              },
              loaded: false,
              extraOptions: chartConfigs.purpleChartOptions,
              gradientColors: [
                "rgba(237, 28, 36, 0.5)",
                "rgba(237, 28, 36, 0.0)",
                "rgba(237, 28, 36, 0.0)"
              ],
              gradientStops: [1, 0.4, 0]
            }
            this.proposedBERChart.loaded = true

            this.ppmDoneChart = {
              chartData: {
                labels: ppmdaterange,
                datasets: [
                  {
                    label: "PPM Done",
                    fill: true,
                    borderColor: "rgba(52, 128, 252, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: "rgba(52, 128, 252, 1)",
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#be55ed",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: PPMDone
                  }
                ]
              },
              loaded: false,
              extraOptions: chartConfigs.purpleChartOptions,
              gradientColors: [
                "rgba(52, 128, 252, 0.7)",
                "rgba(52, 128, 252, 0.0)",
                "rgba(52, 128, 252, 0.0)"
              ],
              gradientStops: [1, 0.4, 0]
            }
            this.ppmDoneChart.loaded = true

            this.ppmUnderMaintenanceChart = {
              chartData: {
                labels: ppmundermaintenance,
                datasets: [
                  {
                    label: "PPM Undermaintenance",
                    fill: true,
                    borderColor: "rgb(140, 100, 203, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: "rgb(140, 100, 203, 1)",
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#be55ed",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: PPMUnderMaintenance
                  }
                ]
              },
              loaded: false,
              extraOptions: chartConfigs.purpleChartOptions,
              gradientColors: [
                "rgba(140, 100, 203, 0.7)",
                "rgba(140, 100, 203, 0.0)",
                "rgba(140, 100, 203, 0)"
              ],
              gradientStops: [1, 0.4, 0]
            }
            this.ppmUnderMaintenanceChart.loaded = true

            this.overduePPMChart = {
              chartData: {
                labels: overdueppmdaterange,
                datasets: [
                  {
                    label: "Overdue PPM",
                    fill: true,
                    borderColor: "rgba(94, 170, 30, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: "rgba(94, 170, 30, 1)",
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#be55ed",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: OverduePPM
                  }
                ]
              },
              loaded: false,
              extraOptions: chartConfigs.purpleChartOptions,
              gradientColors: [
                "rgba(94, 170, 30, 0.5)",
                "rgba(94, 170, 30, 0.0)",
                "rgba(94, 170, 30, 0.0)"
              ],
              gradientStops: [1, 0.4, 0]
            }
            this.overduePPMChart.loaded = true

            this.assetUtilizationChart= {
              chartData: {
                labels: assetutilizationdaterange,
                datasets: [
                  {
                    label: "Asset Utilization",
                    fill: true,
                    borderColor: "rgb(246, 206, 71, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: "rgb(246, 206, 71, 1)",
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#be55ed",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: AssetUtilization
                  }
                ]
              },
              loaded: false,
              extraOptions: chartConfigs.purpleChartOptions,
              gradientColors: [
                "rgba(246, 206, 71, 0.5)",
                "rgba(246, 206, 71, 0.0)",
                "rgba(246, 206, 71, 0.0)"
              ],
              gradientStops: [1, 0.4, 0]
            }
            this.assetUtilizationChart.loaded = true


    },
    getDate(){
      this.breakdownChart.loaded = false
      this.totalassetChart.loaded = false
      this.propertyDhesChart.loaded = false
      this.propertyContractorChart = false
      this.operationalChart.loaded = false
      this.nonOperationalChart.loaded = false
      this.underRepairChart.loaded = false
      this.proposedBERChart.loaded = false
      this.ppmDoneChart.loaded = false
      this.ppmUnderMaintenanceChart.loaded = false
      this.overduePPMChart.loaded = false
      this.assetUtilizationChart.loaded = false

      this.startdate = moment(this.value2[0]).unix()
      this.enddate = moment(this.value2[1]).unix()
      console.log(this.startdate, this.enddate)
      this.getData()
    },
    getData(){
      this.breakdownChart.loaded = false
      this.totalassetChart.loaded = false
      this.propertyDhesChart.loaded = false
      this.propertyContractorChart = false
      this.operationalChart.loaded = false
      this.nonOperationalChart.loaded = false
      this.underRepairChart.loaded = false
      this.proposedBERChart.loaded = false
      this.ppmDoneChart.loaded = false
      this.ppmUnderMaintenanceChart.loaded = false
      this.overduePPMChart.loaded = false
      this.assetUtilizationChart.loaded = false
      
      console.log(`:9996/api/v1/graph/overall/${this.selects.simple_interval}/${this.startdate}/${this.enddate}`)
      this.$http.get(":9996/api/v1/graph/overall/" + this.selects.simple_interval + "/" + this.startdate + "/" + this.enddate)
      .then(res =>{
        if(!res.error){
          let response = res.message
          console.log(response)
          this.getAnalytic(response)
        }
      })
    },
    getSite(){
      this.$http.get(":9996/api/v1/manage/site")
        .then(res =>{
          if(!res.error){
            let response = res.message

            console.log(response)
            let data = {
              label: "All",
              value: "All"
            }
            this.selects.site.push(data)

            for(var i=0; i<response.length; i++){
              let obj = {
                label: response[i].SiteName,
                value: response[i].SiteID
              }
              this.selects.site.push(obj)
            }
            this.selects.simple_site = this.selects.site[0].label
            console.log(this.selects.simple_site)
          }
        })
    },
    getSiteData(){
      console.log(this.selects.simple_site)
      this.breakdownChart.loaded = false
      this.totalassetChart.loaded = false
      this.propertyDhesChart.loaded = false
      this.propertyContractorChart = false
      this.operationalChart.loaded = false
      this.nonOperationalChart.loaded = false
      this.underRepairChart.loaded = false
      this.proposedBERChart.loaded = false
      this.ppmDoneChart.loaded = false
      this.ppmUnderMaintenanceChart.loaded = false
      this.overduePPMChart.loaded = false
      this.assetUtilizationChart.loaded = false

      if(this.selects.simple_site == "All"){
        this.getData()
      } else {
        this.$http.get(":9996/api/v1/graph/" + this.selects.simple_site + "/" + this.selects.simple_interval + "/" + this.startdate + "/" + this.enddate)
        .then(res=>{
          if(!res.error){
            let response = res.message
            console.log(response)
            this.getAnalytic(response)
          }
        })
      }
    }
  },
  created() {
    // get site filter
    this.getSite()
    
    // define first value
    this.startdate = moment().startOf('year').unix()
    this.enddate = moment().endOf('year').unix()
    this.selects.simple_interval = this.selects.interval[0].value
    console.log(this.startdate, this.enddate, this.selects.simple_interval)
    this.getData()
    
    // this.getAnalytic()
  }
};
</script>
<style lang="scss" scoped>
.inline {
  margin-top: 1.5%;
}
hr {
  color: black;
  margin-top: 0%;
}
.card-title > b {
  color: #99e6ff;
}
</style>